import { render, staticRenderFns } from "./Product_details.vue?vue&type=template&id=7d8f836f&scoped=true&"
import script from "./Product_details.vue?vue&type=script&lang=js&"
export * from "./Product_details.vue?vue&type=script&lang=js&"
import style0 from "./Product_details.vue?vue&type=style&index=0&id=7d8f836f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8f836f",
  null
  
)

export default component.exports